// extracted by css-extract-rspack-plugin
var _1 = "CbW2gX6rvzUlyzUL";
var _2 = "VvD7PoFpkNEGIf9S";
var _3 = "MwKtf79zU9EZGFhf";
var _4 = "LpRRZaTUFIO8z2YA";
var _5 = "IQOWn4Wf3w1Yzox4";
export { _1 as "arrow-holder", _2 as "galleryHolder", _3 as "singleSlide", _4 as "slider", _5 as "sliderInnerWrap" }
